/**
 * Route wrapper: allows access when AUTH_TOKEN exists in localStorage.
 * Newly registered pumps are limited to pump details + subscription until they
 * pay or an admin activates them. Owner/Manager are then restricted to the
 * config wizard until STAT_OPERATION === "Yes".
 */
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import {
  configWizardResumePath,
  isConfigWizardPath,
  isOwnerOrManagerRole,
} from './constant/constant'
import {
  isSubscriptionAccessBlocked,
  isSubscriptionGatePath,
  subscriptionResumePath,
} from './utils/subscriptionAccess'

const PrivateRoute = ({ component: Component, ...rest }) => {
  document.addEventListener("wheel", function(event){
		if(document.activeElement.type === "number"){
			document.activeElement.blur();
		}
	});

  let token = '';
  try {
    var checkcookies = 'test';
    localStorage.setItem(checkcookies, checkcookies);
    localStorage.removeItem(checkcookies);
    token = localStorage.getItem("AUTH_TOKEN");
  } catch (e) {
    token = '';
  }

  const isLoggedIn = !!token;

  return (
    <Route
      {...rest}
      render={props => {
        if (!isLoggedIn) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        if (
          isSubscriptionAccessBlocked() &&
          !isSubscriptionGatePath(props.location.pathname)
        ) {
          return <Redirect to={subscriptionResumePath()} />
        }

        const role = localStorage.getItem("ROLE_ID")
        const opsStarted = localStorage.getItem("STAT_OPERATION") === "Yes"
        if (
          isOwnerOrManagerRole(role) &&
          !opsStarted &&
          !isConfigWizardPath(props.location.pathname)
        ) {
          const resumePath = configWizardResumePath()
          const currentPath = String(props.location.pathname || "/")
            .replace(/\/$/, "") || "/"
          if (currentPath === resumePath) {
            return <Redirect to="/pump-details" />
          }
          return <Redirect to={resumePath} />
        }

        return <Component {...props} />
      }}
    />
  )
}

export default PrivateRoute;
